import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M23.06.87a3.07 3.07 0 0 0-4.56.35l-9.93 13a.25.25 0 0 0 .09.37 5.08 5.08 0 0 1 2.4 2.46.26.26 0 0 0 .41.07L23.1 5.26a3.08 3.08 0 0 0-.04-4.39M7.88 15.88a3.66 3.66 0 0 0-4.83 1.83c-.19.43-.33.83-.47 1.2C2.19 20 2 20.53 1 20.79a1.34 1.34 0 0 0-.22 2.51 7.5 7.5 0 0 0 3.14.7 7 7 0 0 0 2.47-.45 6 6 0 0 0 3.32-2.85 3.65 3.65 0 0 0-1.83-4.82"
    }, null, -1)
  ]));
}
const interfaceEditToolPaintBrush = { render };
export {
  interfaceEditToolPaintBrush as default,
  render
};
//# sourceMappingURL=interface-edit-tool-paint-brush.svg.js.map
